import {
  apiRequest,
  commonRequestInstanceToAxiosRequestInfo,
} from '../../api/api.service'
import { API_BASE_URL_STORE, HTTP_METHOD_PUT } from '../../constant'

export const putUpcomingPayments = async ({ data }) => {
  const url = `${API_BASE_URL_STORE}/v1/upcoming-payments`
  const response = await apiRequest(
    commonRequestInstanceToAxiosRequestInfo({
      url,
      method: HTTP_METHOD_PUT,
      needCommonParams: true,
      needCredential: true,
      data,
    }),
  )
  return response
}
